import ExcelImport from '@/core/helper/excel-import';
import { Config } from '@/core/config/config';

const uploadUrl = `${Config.VITE_APP_GATEWAY_URL}/api/account/account-retailer-supplier-location/upload-reatiler-supplier-location`
const templatePath = '/Upload_Retailer_Supplier_Location_Template.xlsx';
const UploadRetailerSupplierLocations = () => {
    return (
        <ExcelImport cardTitle='import-retailer_supplier_location' uploadUrl={uploadUrl} templatePath={templatePath}></ExcelImport>
    )
}
export default UploadRetailerSupplierLocations